import React, { useEffect, useState } from "react";
import NavHeader from "../components/NavHeader";
import {
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  VStack,
  useToast,
} from "@chakra-ui/react";
import cr from "../lib/request";
import { BlogKategori } from "../const/types";
import ComponentSpinner from "../components/ComponentSpinner";
import RestoreBlogKategoriModal from "../components/blogComponents/RestoreBlogCategoryModal";
import useTrigger from "../globalState/useTrigger";
import NoData from "../components/NoData";
import TableContainer from "../components/TableContainer";
import { MagnifyingGlass } from "@phosphor-icons/react";
import formatDate from "../lib/formatDate";
import NoOflinesText from "../components/NoOflinesText";

export default function BlogCategoryRestore() {
  const [search, setSearch] = useState<string>("");
  const [data, setData] = useState<BlogKategori[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const { trigger } = useTrigger();

  useEffect(() => {
    setLoading(true);
    const url = `api/blog/allcategoriesdeleted`;

    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: e.response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [trigger, toast]);

  return (
    <>
      <NavHeader la={"back"} label="Restore Kategori Blog" />

      {!loading && data && data.length > 0 ? (
        <VStack align={"stretch"}>
          <VStack p={5}>
            <InputGroup>
              <InputLeftElement>
                <Icon as={MagnifyingGlass} />
              </InputLeftElement>
              <Input
                placeholder="Pencarian"
                maxW={"400px"}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                value={search}
              />
            </InputGroup>
          </VStack>

          <TableContainer>
            <Table>
              <Thead>
                <Tr>
                  <Th pl={5}>#</Th>
                  {/* <Th>ID</Th> */}
                  <Th>Nama</Th>
                  <Th>Deskripsi</Th>
                  <Th>Dihapus</Th>
                  <Th pr={5} textAlign={"center"} w={"100px"}>
                    Aksi
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                {data.map((kategori, i) => {
                  const ok =
                    kategori.name
                      .toLowerCase()
                      .includes(search.toLowerCase()) ||
                    kategori.id.toString().includes(search);

                  return (
                    ok && (
                      <Tr
                        key={i}
                        _hover={{ bg: "var(--divider)" }}
                        transition={"200ms"}
                      >
                        <Td pl={5} opacity={0.5}>
                          {i + 1}
                        </Td>
                        {/* <Td>{kategori.id}</Td> */}
                        <Td>{kategori.name}</Td>
                        <Td>
                          <NoOflinesText w={"300px"}>
                            {kategori.description}
                          </NoOflinesText>
                        </Td>
                        <Td>{formatDate(kategori.deleted_at)}</Td>
                        <Td pr={5}>
                          <RestoreBlogKategoriModal data={kategori} />
                        </Td>
                      </Tr>
                    )
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </VStack>
      ) : !loading && data && data.length === 0 ? (
        <NoData />
      ) : (
        <ComponentSpinner flex={1} />
      )}
    </>
  );
}
